// @ts-nocheck
export const localeCodes =  [
  "en",
  "da",
  "de",
  "es",
  "fi",
  "fr-CA",
  "fr-FR",
  "it",
  "nl",
  "no",
  "pt-BR",
  "pt-PT",
  "sv"
]
export const localeLoaders = {
  en: [],
  da: [],
  de: [],
  es: [],
  fi: [],
  "fr-CA": [],
  "fr-FR": [],
  it: [],
  nl: [],
  no: [],
  "pt-BR": [],
  "pt-PT": [],
  sv: []
}
export const vueI18nConfigs = []
export const normalizedLocales = [
  {
    code: "en",
    language: undefined
  },
  {
    code: "da",
    language: undefined
  },
  {
    code: "de",
    language: undefined
  },
  {
    code: "es",
    language: undefined
  },
  {
    code: "fi",
    language: undefined
  },
  {
    code: "fr-CA",
    language: undefined
  },
  {
    code: "fr-FR",
    language: undefined
  },
  {
    code: "it",
    language: undefined
  },
  {
    code: "nl",
    language: undefined
  },
  {
    code: "no",
    language: undefined
  },
  {
    code: "pt-BR",
    language: undefined
  },
  {
    code: "pt-PT",
    language: undefined
  },
  {
    code: "sv",
    language: undefined
  }
]
/** client **/

/** client-end **/